import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'


import apis from './http/api.js'
import axios from './http/request.js'
Vue.prototype.$apis = apis
Vue.prototype.$axios = axios

import navigator from '@/utils/navigator'
Vue.prototype.$nav = navigator


import KefuSocket from '@/plugins/kefu-socket'

Vue.use(KefuSocket, { store })

Vue.use(Element)

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')

/* =========================
 * ✅【就加在这里】
 * ========================= */
let __touchFixed = false

if (!__touchFixed) {
  __touchFixed = true
  document.addEventListener(
    'touchstart',
    e => {
      e.stopPropagation()
    },
    true
  )
}
